import profileApi from '@/api/profile/profileApi'
import Customer from '@/classes/case/Customer'
import { Document } from '@/classes/case/Document'

const state = {
  customerProfile: {},
  files: []
}

const mutations = {
  setStateCustomerProfile: (state, data) => {
    state.customerProfile = Customer.asCustomer(data)
  },
  setStateFiles: (state, data) => {
    state.files = data
  }
}

const actions = {
  getCustomerProfile ({ commit }) {
    return profileApi.getCustomerProfile().then((response) => {
      commit('setStateCustomerProfile', response.data)
    }).catch((err) => {
      throw err
    })
  },
  getCustomerFiles ({ commit }, customerId) {
    return profileApi.getFiles(customerId).then((response) => {
      // TODO: should remove when backend is returning the correct structure
      let data = response.data.map((data) => {
        data.data_objects[0].title = data.data_objects[0].label
        return data.data_objects.shift()
      })
      commit('setStateFiles', Document.asDocuments(data))
    }).catch((err) => {
      throw err
    })
  }
}
export default {
  state,
  mutations,
  actions
}
